import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const DateSelectorWrapper = styled.div(() =>
  mq({
    width: '100%',
    marginBottom: [
      defaultTheme.spacing.s,
      defaultTheme.spacing.s,
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
    ],
  }),
);

export const NoRaceText = styled.div(() =>
  mq({
    width: '100%',
    padding: '88px 0',
    backgroundColor: defaultTheme.background.white,
    color: defaultTheme.color.grayScale.dark,
    fontSize: defaultTheme.font.size.m,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }),
);

export const TabWrapper = styled.div(() =>
  mq({
    width: ['90%', '90%', '90%', '842px'],
    margin: [
      `0 auto ${defaultTheme.spacing.l}`,
      `0 auto ${defaultTheme.spacing.l}`,
      `0 auto ${defaultTheme.spacing.xxl}`,
      `0 auto ${defaultTheme.spacing.xxl}`,
    ],
  }),
);

export const RaceProgramListWrapper = styled.div((props: { isShow: boolean }) =>
  mq({
    display: props.isShow ? 'block' : 'none',
    width: '100%',
  }),
);
